(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buy-buttons"] && !Shopify.designMode) return;
  try {
    const defaults = {
    name: "First Name",
    position: "Financial Advisor",
    address: "123 Address St",
    tel: "123-456-7890",
    email: "youremail@email.com",
    web: "www.edwardjones.ca"
};

const inputFields = document.querySelectorAll('input[data-input-for]');

inputFields.forEach(input => {
    input.addEventListener('input', function () {
        const key = this.dataset.inputFor;
        const value = this.value.trim();
        const displayEls = document.querySelectorAll(`[data-bind="${key}"]`);
        displayEls.forEach(el => el.textContent = value || defaults[key]);
    });
});

const addToCartBtn = document.querySelector('button[name="add"]');

if (addToCartBtn) {
    addToCartBtn.addEventListener('click', () => {

        inputFields.forEach(input => {
            const key = input.dataset.inputFor;
            if (input.value.trim() === "") {
                input.value = defaults[key];   
            }
        });

    }, true); 
}


document.addEventListener('DOMContentLoaded', () => {
  const consent = document.querySelector('[data-consent]');
  const addToCart = document.querySelector('button[name="add"]');

  if (!consent || !addToCart) return;

  addToCart.disabled = true;

  consent.addEventListener('change', () => {
    addToCart.disabled = !consent.checked; // disable the add to cart button when the checkbox is unchecked
  });
});
  } catch(e) { console.error(e); }
})();

})();
